import dayjs from 'dayjs';
import { getTheme } from './theme';

// import { formatCurrency } from './format';
import { formatCurrency } from './currency';
import { STORE_IDS_WITH_OFFER_TEXT, DEFAULT_OFFER_DEALER_TEXT } from './store';

const OfferExpirationDays = 7;

const theme = getTheme('light');
export const conditions = {
  Rough: {
    color: theme.colors.conditionRough,
    percentage: '34%',
  },
  Just_Okay: {
    color: theme.colors.justOkay,
    percentage: '64%',
  },
  Excellent: {
    color: theme.colors.excellent,
    percentage: '2%',
  },
};

export const offerConditions = {
  Accident: 'accident',
  Title: 'title',
  TireIssues: 'tire_issues',
  BodyDamage: 'body_damage',
  InteriorIssues: 'interior_issues',
  Modifications: 'modifications',
  AccidentTypes: {
    None: 'none',
    Once: 'once',
    Twice: 'twice',
  },
  OfferPercentages: {
    Low: {
      type: 'below',
      percentage: 12,
    },
    Medium: {
      type: 'below',
      percentage: 4,
    },
    High: {
      type: 'above',
      percentage: 6,
    },
  },
};

const generateAccidentMessage = (type, locale) => {
  switch (type) {
    case offerConditions.AccidentTypes.None:
      return locale.disclosureNoAccident;
    case offerConditions.AccidentTypes.Once:
      return locale.disclosureAccident;
    case offerConditions.AccidentTypes.Twice:
      return locale.disclosureTwoAccident;
    default:
      return locale.disclosureNoAccidentRecords;
  }
};

export const computeConditions = (disclosures, locale) => {
  const generatedConditions = {};
  Object.keys(offerConditions).forEach((key) => {
    switch (offerConditions[key]) {
      case offerConditions.Accident:
        generatedConditions.accident = generateAccidentMessage(
          disclosures?.accident,
          locale
        );
        break;
      case offerConditions.Title:
        generatedConditions.title =
          disclosures?.title_present && !disclosures.title_branded
            ? locale.disclosureTitleNotClean
            : locale.disclosureTitleClean;

        break;
      case offerConditions.TireIssues:
        generatedConditions.tireIssues =
          disclosures?.tire_tread === locale.disclosureGoodTires &&
          !disclosures?.tire_issues
            ? locale.disclosureTiresClean
            : locale.disclosureTireIssues;

        break;
      case offerConditions.BodyDamage:
        generatedConditions.bodyDamage = disclosures?.body_damage
          ? (generatedConditions.bodyDamage =
              locale.disclosureBodyDamage.replace(
                '{0}',
                disclosures?.body_damage_severity
              ))
          : (generatedConditions.bodyDamage = locale.disclosureNoBodyDamage);

        break;
      case offerConditions.InteriorIssues:
        generatedConditions.interiorIssues = disclosures?.interior_issues
          ? locale.disclosureInteriorIssues
          : locale.disclosureInteriorNoIssues;

        break;
      case offerConditions.Modifications:
        generatedConditions.modifications = disclosures?.modifications
          ? locale.disclosureModifications
          : locale.disclosureNoModifications;

        break;
      default:
      // do nothing
    }
  });
  return generatedConditions;
};

export const calculateValuePercentage = (value, percentage, type) => {
  let newValue = 0;
  type === 'above'
    ? (newValue = value + (percentage / 100) * value)
    : (newValue = value - (percentage / 100) * value);
  return value ? formatCurrency(newValue) : 0;
};

export const getOfferValue = (offerValue, offerRangeValue) => {
  if (offerRangeValue) {
    const offerRangeValueSplit = offerRangeValue.split(',');
    if (!offerRangeValueSplit.length) {
      return 0;
    }

    if (offerRangeValueSplit.length === 2) {
      return `${formatCurrency(offerRangeValueSplit[0])} - ${formatCurrency(
        offerRangeValueSplit[1]
      )}`;
    }

    return formatCurrency(offerRangeValueSplit[0]);
  }

  return offerValue ? formatCurrency(offerValue) : 0;
};

export const getOfferExpirationDate = (createdDate) => {
  const expirationDate = dayjs(createdDate);
  return expirationDate.add(OfferExpirationDays, 'd');
};

export const DefaultOfferDiff = { days: 0, hours: 0, minutes: 0 };

export const computeExpirationDiff = (createdDate) => {
  const expirationDate = getOfferExpirationDate(createdDate);
  const currentDate = dayjs();

  const days = expirationDate.diff(currentDate, 'd');

  const expirationLessDays = expirationDate.subtract(days, 'd');
  const hours = expirationLessDays.diff(currentDate, 'h');

  const expirationLessHours = expirationLessDays.subtract(hours, 'h');
  const minutes = expirationLessHours.diff(currentDate, 'm');

  return { days, hours, minutes };
};

export const getStoreConfig = (storeId) => {
  // Check if the store ID is in the list of stores with offer dealer text
  if (STORE_IDS_WITH_OFFER_TEXT.includes(storeId)) {
    return {
      id: storeId,
      offerDealerText: DEFAULT_OFFER_DEALER_TEXT
    };
  }
  // Return null for stores that don't have specific offer dealer text
  return null;
};
